import React from 'react';
import './Products.css';

const Products = () => {
    const products = [
        {
            id: 1,
            name: "Enterprise Solution",
            description: "Complete business management platform with advanced analytics and reporting capabilities.",
            price: "$299/month",
            features: ["Advanced Analytics", "Custom Reports", "24/7 Support", "API Integration"]
        },
        {
            id: 2,
            name: "Professional Suite",
            description: "Mid-tier solution perfect for growing businesses with essential tools and features.",
            price: "$149/month",
            features: ["Basic Analytics", "Standard Reports", "Email Support", "Third-party Integrations"]
        },
        {
            id: 3,
            name: "Starter Package",
            description: "Entry-level solution for small businesses and startups getting started.",
            price: "$49/month",
            features: ["Basic Dashboard", "Simple Reports", "Community Support", "Core Features"]
        }
    ];

    return (
        <div className="products-container">
            <div className="products-header">
                <h1>Our Products</h1>
                <p>Discover our comprehensive range of business solutions designed to help your organization thrive.</p>
            </div>
            
            <div className="products-grid">
                {products.map(product => (
                    <div key={product.id} className="product-card">
                        <div className="product-header">
                            <h3>{product.name}</h3>
                            <div className="product-price">{product.price}</div>
                        </div>
                        <p className="product-description">{product.description}</p>
                        <div className="product-features">
                            <h4>Key Features:</h4>
                            <ul>
                                {product.features.map((feature, index) => (
                                    <li key={index}>{feature}</li>
                                ))}
                            </ul>
                        </div>
                        <button className="product-cta">Learn More</button>
                    </div>
                ))}
            </div>
            
            <div className="products-footer">
                <h3>Need a Custom Solution?</h3>
                <p>Contact our team to discuss your specific requirements and get a tailored solution.</p>
                <button className="contact-button">Contact Sales</button>
            </div>
        </div>
    );
};

export default Products;
